module.exports = __webpack_public_path__ + "img/icon-ppt.55ac155e.svg";